import React from "react";
import { Switch, Route } from "react-router-dom";
import MapBox from "../components/MapBox";
import Calculator from "../components/Calculator";
import LogIn from "../components/LogIn";
import Estimator from "../components/Estimator";
import Profile from "../components/Profile";

export default function Body(props) {
  const {
    authClient,
    isUserOpen,
    showSecondFiler,
    setShowSecondFiler,
    appProps,
  } = props;
  return (
    <div>
      <Switch>
        <Route path="/" exact component={Calculator} appProps={appProps} />
        <Route
          path="/map"
          exact
          component={MapBox}
          appProps={{ showSecondFiler, setShowSecondFiler }}
        />
        <Route path="/login" exact component={LogIn} />
        <Route path="/profile" exact component={Profile} appProps={props} />
        <Route path="/estimator" exact component={Estimator} appProps={props} />
      </Switch>
    </div>
  );
}
